import React, { useEffect } from 'react';
import { ProgressBarLoader } from '../components/ProgressBarLoader/ProgressBarLoader';
import { createPortal } from 'react-dom';
import { usePanorama } from '../context/PanoramaContext';
export const useHandleNewWindow = () => {
  const {
    errorMonitor
  } = usePanorama();
  const windowReference = React.useRef(null);
  const reactPortal = React.useRef(null);
  const broadcastChannel = React.useRef(new BroadcastChannel('oauth_installer_bc'));
  useEffect(() => {
    const bc = broadcastChannel.current;
    return () => {
      bc.close();
    };
  }, []);
  return {
    broadcastChannel: broadcastChannel.current,
    openWindow: () => {
      windowReference.current = window.open('', '_blank');
    },
    showLoader: () => {
      try {
        if (windowReference != null && windowReference.current) {
          reactPortal.current = /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(ProgressBarLoader, null), windowReference.current.document.body);
        }
      } catch (e) {
        var _errorMonitor;
        (_errorMonitor = errorMonitor()) == null || _errorMonitor.reportError(e);
      }
    },
    closeWindow: () => {
      if (windowReference.current) {
        windowReference.current.close();
      }
    },
    navigateToSecondRedirectUrlInOauth: url => {
      broadcastChannel.current.postMessage({
        type: 'navigateToRedirectUrl',
        redirectUrl: url
      });
    },
    updateWindowSrcWithUrl: url => {
      if (windowReference.current) {
        windowReference.current.location.href = url;
      }
    },
    navigateToPostInstallationUrlInOauth: url => {
      // navigate to post installation happens only in advanced oauth apps when they reach the second redirect.
      // has to be window post message because installer v1 is with generic subdomain and doesn't have a token
      if (windowReference.current) {
        windowReference.current.postMessage({
          type: 'navigatePostInstallation',
          url
        }, '*');
      }
    },
    avoidPostInstallationPostMessageInOauth: () => {
      if (windowReference.current) {
        windowReference.current.postMessage({
          type: 'avoidPostInstallation'
        }, '*');
      }
    },
    NewWindowPortal: reactPortal.current
  };
};
export const initNewWindowHandlers = {
  broadcastChannel: {},
  openWindow: () => {},
  closeWindow: () => {},
  updateWindowSrcWithUrl: () => {},
  navigateToSecondRedirectUrlInOauth: () => {},
  navigateToPostInstallationUrlInOauth: () => {},
  avoidPostInstallationPostMessageInOauth: () => {},
  showLoader: () => {},
  NewWindowPortal: null
};
//# sourceMappingURL=useHandleNewWindow.js.map